import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrConversationStage.ts
var t = () => e("conversationStage");
//#endregion
export { t as useTrConversationStage };
